import PreviewExpandable from 'app/features/questionnaires/components/PreviewExpandable';
import { useSelector } from 'react-redux';
import { selectQuestionnaireRoutes } from '../../routes/slice';
import PreviewTheBasics from './TheBasics/preview';
import PreviewWhereILive from './WhereILive/preview';

export interface IPreviewPersonalDetailsProps {}

export default function PreviewPersonalDetails(
  props: IPreviewPersonalDetailsProps,
) {
  const routes = useSelector(selectQuestionnaireRoutes).routes;

  return (
    <>
      <PreviewExpandable title="Personal Details">
        {routes.personal_details.the_basics && <PreviewTheBasics />}
        {routes.personal_details.where_i_live && <PreviewWhereILive />}
      </PreviewExpandable>
    </>
  );
}
